module.exports = __webpack_public_path__ + "static/media/faq_(3).eaa875c2.gif";